/**
 * Fallback content loader. Returns markdown for known article slugs or a
 * generic HTML snippet when no specific fallback exists.
 */
import harmfulContent from '@/data/fallback/harmful-content-detection.md?raw';
import youtubeContent from '@/data/fallback/youtube-recommendation-system.md?raw';

/** Map of article slug to fallback markdown content */
const fallbackMap: Record<string, string> = {
  'harmful-content-detection': harmfulContent,
  'youtube-recommendation-system': youtubeContent,
};

export const getFallbackContent = (slug: string): string => {
  const markdown = fallbackMap[slug];
  if (markdown) {
    return markdown;
  }

  return `
    <div class="p-6 bg-amber-50 border border-amber-200 rounded-lg">
      <h2 class="text-2xl font-semibold mb-3">Article Content</h2>
      <p class="mb-4">We're currently experiencing technical difficulties loading this article.
      Please check back later or try refreshing the page.</p>
      <p class="text-sm text-gray-600">Article ID: ${slug}</p>
    </div>
  `;
};

/** Export the map for potential external use */
export { fallbackMap };
